var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-viewer",on:{"mouseover":_vm.showIcon,"mouseleave":_vm.hideIcon,"click":_vm.showViewer}},[_c('img',{ref:"image",attrs:{"src":_vm.src,"alt":"图片"}}),_vm._v(" "),_c('i',{staticClass:"view-icon fa fa-eye"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33307cd5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/dialog/ImageViewer.vue
// module id = null
// module chunks = 